import filtype from './filtype'

const temarapporter = {
    fartsgrense_og_ulykker: {
        aktivertITrine: false,
        tekniskNavn: 'fartsgrense_og_ulykker',
        visningsnavn: 'Fartsgrense og ulykker',
        filtyper: [filtype.pdf]
    },
    bilforer_65_pluss_ulykker: {
        aktivertITrine: false,
        tekniskNavn: 'bilforer_65_pluss_ulykker',
        visningsnavn: 'Bilfører 65+, ulykker',
        filtyper: [filtype.pdf]
    },
    del_vegen: {
        aktivertITrine: false,
        tekniskNavn: 'del_vegen',
        visningsnavn: 'Del vegen',
        filtyper: [filtype.pdf]
    },
    tiltaksplanens_ulykkesrapport: {
        aktivertITrine: true,
        tekniskNavn: 'tiltaksplanens_ulykkesrapport',
        visningsnavn: 'Tiltaksplanens ulykkesrapport',
        filtyper: [filtype.pdf]
    },
    ulykkespunkt_ulykkesstrekninger: {
        aktivertITrine: true,
        tekniskNavn: 'ulykkespunkt_ulykkesstrekninger',
        visningsnavn: 'Ulykkespunkt og ulykkesstrekninger',
        filtyper: [filtype.xlsx]
    }
}

export default temarapporter
